module.exports = __webpack_public_path__ + "img/google-review.38836315.png";